import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import PropertyFactory from "../../Entity/Factories/PropertyFactory";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";
import { ActionInterface } from "../../Interface/ActionInterface";

export function* propertyUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_PROPERTY_UPDATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_PROPERTY_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `properties/${action.payload?.id}`, action.payload?.property);

    const property: PropertyInterface = PropertyFactory.create(res.data.data);

    yield put({
      type: Constants.PAGE_PROPERTY_UPDATE_SUCCESS,
      payload: {
        property: property
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        type: "success",
        message: Translator.trans("snackbar-message-property-updated-successfully")
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_PROPERTY_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPropertyUpdate() {
  yield takeEvery(Constants.PAGE_PROPERTY_UPDATE_START, propertyUpdate);
}
